module.exports = __webpack_public_path__ + "img/logocb.b84d4376.png";